import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { quotaQueryKeys } from "app/pages/sales-intelligence/modules/quota/queries/keys";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import type { DataCreditsOperationCost } from "../types";

export const useStaticLeadsDataCreditsCostsQuery = () => {
    return useQuery<DataCreditsOperationCost>({
        enabled: salesSettingsHelper.isDataCreditsEnabled,
        queryKey: quotaQueryKeys.leadsDataCreditCosts(),
        queryFn({ signal }) {
            return salesApiService.quota.fetchStaticLeadsDataCreditsCosts({ cancellation: signal });
        },
        placeholderData: keepPreviousData,
    });
};
